import React from 'react';
import BlankSlate from '../../_shared/blank_slate/_blank_slate.js';
import Icon from '../../_shared/blank_slate/icon.js';
import Description from '../../_shared/blank_slate/description.js';

const IndexBlankSlate = props => (
  <div className="Index-blankSlate">
    <BlankSlate large>
      {props.image && (
        <img className="mh-300" src={props.image} alt={props.description} />
      )}
      {props.icon && !props.image && <Icon src={props.icon} />}
      <br />
      {props.title && <h2 className="ff-ss mt-16">{props.title}</h2>}
      <Description>{props.description}</Description>
      {!!props.additionalDescription && (
        <Description>{props.additionalDescription}</Description>
      )}
      {props.children}
    </BlankSlate>
  </div>
);

export default IndexBlankSlate;
